// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","455":"04ab6e83","488":"f40f558f","977":"865031d6"}[chunkId] + ".chunk.js";
};